const PLAYER_STORAGE_KEY = 'daznPlayer';

export default PLAYER_STORAGE_KEY;